import React from 'react';
import LiveNowIcon from 'components_v2/common/InitNewscardComponents/LiveNowIcon';
import s from './NewStoryCard.scss';

export default function IconWrapper({
  iconClass,
  sectionNameTop,
  inlineCard,
  cardType,
  videoTime,
  cmstype,
  liveIconText,
}) {
  const iconClass2 = cardType === 'card_9' ? s.vsIcon : '';
  if (!inlineCard) {
    return null;
  }
  if (!(iconClass || sectionNameTop || videoTime || cmstype === 'LIVEBLOG')) {
    return null;
  }
  return (
    <section className={`${s.iconWrap}`}>
      {iconClass &&
        cmstype !== 'LIVEBLOG' && (
          <span className={`${s[iconClass]} ${iconClass2} ${s.smallIcon}`}>
            <i />
            {videoTime && <span> {videoTime} </span>}
          </span>
        )}

      {/* Live Indicator for card_8 */}
      {cmstype === 'LIVEBLOG' && (
        <div className={s.liveBlinker}>
          <LiveNowIcon text={liveIconText || 'Live'} />
        </div>
      )}
    </section>
  );
}
